<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__accent">
      {{ 'GENERAL.BULK_STORE_CREATION_CTA' | translate }}
    </h3>

    <div *ngIf="!show_results">
      <p
        class="sp-color__primary sp-margin__top sp-margin__bottom-x2"
        [innerHTML]="'GENERAL.BULK_STORE_CREATION_LABEL' | translate"></p>

      <button
        *ngIf="!is_csv_upload_running"
        mat-button
        (click)="file_upload.click()"
        class="sp-width__full sp-button__dashed-accent sp-bank-account__height sp-margin__vert-x2">
        <mat-icon matPrefix> upload </mat-icon>
        <span
          *ngIf="!file_name"
          class="sp-color__primary">
          {{ 'GENERAL.BULK_STORE_CREATION_CTA' | translate }} (.csv)
        </span>
        <span
          *ngIf="file_name"
          class="sp-color__primary">
          {{ file_name }}
        </span>
      </button>

      <input
        type="file"
        accept="text/csv"
        class="sp-display__none"
        (change)="onFileLoaded($event)"
        #file_upload />

      <div class="sp-margin__top">
        <app-shared-button
          class="sp-width__full"
          [button_class]="'sp-button__main'"
          [spinner_class]="'sp-spinner__main'"
          [cta]="'GENERAL.CONFIRM_CTA'"
          [is_disabled]="isConfirmButtonDisabled()"
          [is_spinner_visible]="is_csv_upload_running"
          (click)="onConfirmClick()"></app-shared-button>
      </div>
    </div>

    <div
      *ngIf="show_results && result"
      class="sp-margin__top">
      <div class="sp-margin__bottom">
        <p>{{ 'GENERAL.BULK_STORE_CREATION_PROCESSED' | translate }}: {{ result.total }}</p>
        <p>{{ 'GENERAL.BULK_STORE_CREATION_SUCCEEDED' | translate }}: {{ result.success }}</p>
        <p>{{ 'GENERAL.BULK_STORE_CREATION_FAILED' | translate }}: {{ result.failed }}</p>
      </div>

      <div *ngIf="result.errors.length > 0">
        <h4 class="sp-color__accent">Errors:</h4>
        <div *ngFor="let error of result.errors">
          <p>Row {{ error.row }}: {{ error.error }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
